import { APICall } from "@/config/NetworkUtility";
import { COMPANY_REQUEST_DETAIL, COMPANY_REQUEST_LIST, MASTER_COMPANY_LIST, MASTER_COMPANY_LIST_ERROR, UPDATE_COMPANY_REQUEST_STATUS } from "./constant";
import { callLoader } from "@/redux/Loader/actions";

const logImportApiError = (label, error, payload) => {
    console.error(`❌ ${label} failed`, {
        url: error?.config?.url,
        method: error?.config?.method,
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        responseData: error?.response?.data,
        message: error?.message,
        payload,
    });
};

export const registerMasterCompany = (payload) => {
    return async (dispatch) => {

        try {

            const url =
                `/v2/CompanySetup/MasterCompanyRegister`;

            const result = await APICall(
                "post",
                payload,
                url
            );

            if (
                result?.statuscode === 200 ||
                result?.statuscode === 201
            ) {

                return result;
            }

            return Promise.reject(result);

        } catch (error) {

            logImportApiError(
                "registerMasterCompany",
                error,
                payload
            );

            return Promise.reject(error);
        }
    };
};

export const updateMasterCompany = (payload) => {
  return async (dispatch) => {
    try {
      const url = `/v2/CompanySetup/UpdateMasterCompany`;

      const result = await APICall(
        "post",
        payload,
        url,
      );

      if (
        result?.statuscode === 200 ||
        result?.statuscode === 201
      ) {
        return result;
      }

      return Promise.reject(result);
    } catch (error) {
      logImportApiError(
        "updateMasterCompany",
        error,
        payload,
      );

      return Promise.reject(error);
    }
  };
};


export const getMasterCompanyList = (payload) => {
  return async (dispatch) => {
    try {
        dispatch(callLoader(true));
        
          const cleanedPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, v]) => v !== null && v !== undefined && v !== "",
        ),
      );

       const queryParams = new URLSearchParams(cleanedPayload).toString();
      const url = `/v1/CompanySetup/GetMasterCompanyList?${queryParams}`;

        const result = await APICall(
            { method:"get",
            endpoint:url,}
        );

      if (
        result?.statuscode === 200 ||
        result?.statuscode === 201
      ) {
        const responsePayload = {
          data: result?.data || [],

          pagination: result?.pagination || {
            totalRecord: 0,
            currentRecord: 0,
            currentPage: 1,
            nextPage: 0,
            totalPage: 1,
          },
        };

        dispatch({
          type: MASTER_COMPANY_LIST,
          payload: responsePayload,
        });

        return responsePayload;
        }
        
         dispatch({
        type: MASTER_COMPANY_LIST_ERROR,
        payload: result?.message || "Failed to fetch company list.",
      });

      return Promise.reject(result);
    } catch (error) {
      logImportApiError(
        "getMasterCompanyList",
        error,
        payload,
        );
        
         dispatch({
        type: MASTER_COMPANY_LIST_ERROR,
        payload: error?.message || "Unexpected error fetching company list.",
      });

      return Promise.reject(error);
    } finally {
      dispatch(callLoader(false));
    }
  };
};

export const GetCompanyRequestList = (
    payload,
    forceRefresh = false
) => {

    return async (dispatch, getState) => {

        try {

            const cacheKey = JSON.stringify({
                IPageNo: payload.IPageNo,
                IPageRecords: payload.IPageRecords,
                SearchKeyword: payload.SearchKeyword,
                FilterType: payload.FilterType,
            });

            const state = getState();

            const companyRequestCache =
                state?.masterCompany?.companyRequestCache || {};

            const cachedData = companyRequestCache[cacheKey];

            const CACHE_TIME = 5 * 60 * 1000;

            if (
                !forceRefresh &&
                cachedData &&
                Date.now() - cachedData.timestamp < CACHE_TIME
            ) {
                // FIX: must still dispatch to Redux so the UI
                // (companyRequestList + pagination) reflects the cached page
                dispatch({
                    type: COMPANY_REQUEST_LIST,
                    payload: cachedData.response,
                });

                return cachedData.response;
            }

            const queryParams =
                new URLSearchParams(payload).toString();

            const url =
                `/v1/CompanySetup/GetCompanyRequestList?${queryParams}`;

            const result = await APICall("get", null, url);

            if (
                result?.statuscode === 200 ||
                result?.statuscode === 201
            ) {

                const responsePayload = {
                    data: result?.data || [],
                    pagination: result?.pagination || {},
                };

                dispatch({
                    type: COMPANY_REQUEST_LIST,
                    payload: responsePayload,
                });

                dispatch({
                    type: "CACHE_COMPANY_REQUEST_LIST",
                    payload: {
                        key: cacheKey,
                        response: responsePayload,
                        timestamp: Date.now(),
                    },
                });

                return responsePayload;
            }

            return Promise.reject(result);

        } catch (error) {

            return Promise.reject(error);
        }
    };
};

export const updateCompanyRequestStatus = (payload) => {
    return async (dispatch) => {
        try {
            const url = `/v2/CompanySetup/ProcessCompanyRequest`;

            const result = await APICall(
                "post",
                payload,
                url
            );

            if (result?.statuscode === 200 || result?.statuscode === 201) {

                dispatch({
                    type: UPDATE_COMPANY_REQUEST_STATUS,
                    payload,
                });

                return result;
            }

            return Promise.reject(result);

        } catch (error) {
            logImportApiError(
                "updateCompanyRequestStatus",
                error,
                payload
            );

            return Promise.reject(error);
        }
    };
};